import ButtonT from '@components/tailwind-components/Button/ButtonT';
import InputWithLabelT from '@components/tailwind-components/Input/InputWithLabelT';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useUserDataMapping } from '../../../../hooks/flow/user-data-mapping/useUserDataMapping';
import { useUserDataMappingActions } from '../../../../hooks/flow/user-data-mapping/useUserDataMappingActions';
import { useModal } from '../../../../hooks/modal/useModal';
import type { TUserDataMappingCongig } from '../../../../interfaces/redux/TSettingsState';

export const ManageUserDataMappingModal = () => {
  const { userDataMapping } = useUserDataMapping();
  const { updateUserDataMapping } = useUserDataMappingActions();
  const { t } = useTranslation();
  const { hideModal } = useModal();

  const hideAndSubmit = (data: TUserDataMappingCongig) => {
    updateUserDataMapping(data);
    hideModal();
  };

  const { handleSubmit, control } = useForm({
    shouldUseNativeValidation: true,
    defaultValues: {
      email: userDataMapping?.email,
      name: userDataMapping?.name,
      address: userDataMapping?.address,
      phone: userDataMapping?.phone,
    },
  });

  return (
    <form
      className='tailwind-modal-form'
      onSubmit={handleSubmit(hideAndSubmit)}>
      <div className='tailwind-modal-body'>
        <div className='grid grid-cols-1 gap-x-6 gap-y-2'>
          <div className='col-span-1'>
            <InputWithLabelT
              type='text'
              field='name'
              label={t('app-settings.user-data-mapping.name')}
              placeholder={t('app-settings.user-data-mapping.name')}
              id='name'
              control={control}
            />
            <InputWithLabelT
              type='email'
              field='email'
              label={t('app-settings.user-data-mapping.email')}
              placeholder={t('app-settings.user-data-mapping.email')}
              id='email'
              control={control}
            />
            <InputWithLabelT
              type='text'
              field='phone'
              label={t('app-settings.user-data-mapping.phone')}
              placeholder={t('app-settings.user-data-mapping.phone')}
              id='phone'
              control={control}
            />
            <InputWithLabelT
              type='text'
              field='address'
              label={t('app-settings.user-data-mapping.address')}
              placeholder={t('app-settings.user-data-mapping.address')}
              id='address'
              control={control}
            />
          </div>
        </div>
      </div>
      <div className='tailwind-modal-footer'>
        <ButtonT
          type='button'
          styling='cancel'
          size='xs'
          rounding='md'
          onClick={hideModal}>
          {t('general.buttons.cancel')}
        </ButtonT>
        <ButtonT type='submit' styling='primary' size='xs' rounding='md'>
          {t('general.buttons.save')}
        </ButtonT>
      </div>
    </form>
  );
};
